import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDeliveryMode } from '../utils/deliveryMode';

/** Aviso no palco quando um elemento de site está no modo Curso. */
export default function SiteOnlyCourseNotice() {
  const { t } = useTranslation('builder');
  const deliveryMode = useDeliveryMode();
  if (deliveryMode !== 'course') return null;

  return (
    <div
      role="note"
      className="mx-2 mt-2 mb-1 px-3 py-2 rounded-lg border border-amber-300 bg-amber-50 text-amber-950 text-xs leading-relaxed"
    >
      {t('siteWidgetInCourseNotice')}
    </div>
  );
}
